import React, { useEffect, useState } from "react";
import api from '../../api/axiosInstance';
import AdminLayout from "../../components/admin/AdminLayout";
import { Button, Form } from "react-bootstrap";

const AdminUsers = () => {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");

  // ▼ Sıralama State
  const [sortConfig, setSortConfig] = useState({ key: "name", direction: "asc" });

  // ▼ Sayfalama State
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;

  const loadUsers = async () => {
    try {
      const token = localStorage.getItem("token");

      const res = await api.get("/admin/users", {
        headers: { Authorization: `Bearer ${token}` },
      });

      setUsers(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  const approveUser = async (id) => {
    const token = localStorage.getItem("token");

    await api.put(
      `/admin/users/${id}/approve`,
      {},
      { headers: { Authorization: `Bearer ${token}` } }
    );

    loadUsers();
  };

  const unapproveUser = async (id) => {
    const token = localStorage.getItem("token");

    if (!window.confirm("Onayı kaldırmak istediğinize emin misiniz?")) return;

    await api.put(
      `/admin/users/${id}/unapprove`,
      {},
      { headers: { Authorization: `Bearer ${token}` } }
    );

    loadUsers();
  };

  const changeRole = async (id, role) => {
    const token = localStorage.getItem("token");

    await api.patch(
      `/admin/users/${id}/role`,
      { role },
      { headers: { Authorization: `Bearer ${token}` } }
    );

    loadUsers();
  };

  useEffect(() => {
    loadUsers();
  }, []);

  const calculateLicenseEnd = (approvedAt) => {
    if (!approvedAt) return "-";
    const endDate = new Date(new Date(approvedAt).getTime() + 365 * 86400000);
    return endDate.toLocaleDateString("tr-TR");
  };

  // 🔍 Arama Filtresi
  const filteredUsers = users.filter((u) => {
    const q = search.toLowerCase();
    return (
      u.name.toLowerCase().includes(q) ||
      u.email.toLowerCase().includes(q) ||
      (u.phone || "").toLowerCase().includes(q)
    );
  });

  // 🔽 Sıralama Fonksiyonu
  const sortedUsers = [...filteredUsers].sort((a, b) => {
    const { key, direction } = sortConfig;
    let valA = a[key] || "";
    let valB = b[key] || "";

    // Tarih sıralaması için
    if (key === "approvedAt" && valA && valB) {
      valA = new Date(valA);
      valB = new Date(valB);
    }

    if (typeof valA === "string") valA = valA.toLowerCase();
    if (typeof valB === "string") valB = valB.toLowerCase();

    if (valA < valB) return direction === "asc" ? -1 : 1;
    if (valA > valB) return direction === "asc" ? 1 : -1;
    return 0;
  });

  // 📌 Sayfalama
  const totalPages = Math.ceil(sortedUsers.length / pageSize);
  const paginatedUsers = sortedUsers.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  // ▶ Sıralama değiştirici
  const changeSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
    }));
  };

  return (
    <AdminLayout>
      <h2>👤 Kullanıcı Yönetimi</h2>

      {/* 🔎 ARAMA KUTUSU */}
      <Form.Control
        type="text"
        placeholder="Kullanıcı Ara (İsim, Email, Telefon)"
        className="mt-3 mb-3"
        value={search}
        onChange={(e) => {
          setSearch(e.target.value);
          setCurrentPage(1);
        }}
      />

      <table className="table mt-3">
        <thead>
          <tr>
            <th onClick={() => changeSort("name")} style={{ cursor: "pointer" }}>İsim</th>
            <th onClick={() => changeSort("email")} style={{ cursor: "pointer" }}>E-posta</th>
            <th onClick={() => changeSort("phone")} style={{ cursor: "pointer" }}>Telefon</th>
            <th onClick={() => changeSort("category")} style={{ cursor: "pointer" }}>Meslek</th>
            <th onClick={() => changeSort("isApproved")} style={{ cursor: "pointer" }}>Onay</th>
            <th onClick={() => changeSort("approvedAt")} style={{ cursor: "pointer" }}>Lisans Bitiş</th>
            <th onClick={() => changeSort("role")} style={{ cursor: "pointer" }}>Rol</th>
            <th>İşlemler</th>
          </tr>
        </thead>

        <tbody>
          {paginatedUsers.map((u) => (
            <tr key={u._id}>
              <td>{u.name}</td>
              <td>{u.email}</td>
              <td>{u.phone || "-"}</td>
              <td>{u.category}</td>
              <td>{u.isApproved ? "Onaylı" : "Bekliyor"}</td>
              <td>{calculateLicenseEnd(u.approvedAt)}</td>
              <td>{u.role}</td>

              <td>
                {!u.isApproved && (
                  <Button
                    size="sm"
                    variant="success"
                    className="me-2"
                    onClick={() => approveUser(u._id)}
                  >
                    Onayla
                  </Button>
                )}

                {u.isApproved && (
                  <Button
                    size="sm"
                    variant="danger"
                    className="me-2"
                    onClick={() => unapproveUser(u._id)}
                  >
                    Onayı Kaldır
                  </Button>
                )}

                {u.role !== "admin" ? (
                  <Button
                    size="sm"
                    variant="warning"
                    onClick={() => changeRole(u._id, "admin")}
                  >
                    Admin Yap
                  </Button>
                ) : (
                  <Button
                    size="sm"
                    variant="secondary"
                    onClick={() => changeRole(u._id, "user")}
                  >
                    User Yap
                  </Button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* 📌 SAYFALAMA BUTONLARI */}
      <div className="d-flex justify-content-center mt-3">
        <Button
          variant="outline-primary"
          disabled={currentPage === 1}
          onClick={() => setCurrentPage((p) => p - 1)}
          className="me-2"
        >
          ‹ Önceki
        </Button>

        <span className="align-self-center">
          Sayfa {currentPage} / {totalPages}
        </span>

        <Button
          variant="outline-primary"
          disabled={currentPage === totalPages}
          onClick={() => setCurrentPage((p) => p + 1)}
          className="ms-2"
        >
          Sonraki ›
        </Button>
      </div>
    </AdminLayout>
  );
};

export default AdminUsers;
